import React, { FC } from 'react'
import Modal from 'components/SA/Modal/v2'
import { ModalComponentProps } from './Auth'
import styles from './Auth.module.scss'
import ResetPassword from '../Forms/ResetPassword'

export const MODAL_NAME = 'reset'

const ResetPasswordModal: FC<ModalComponentProps> = (props) => {
  const { closeModal } = props
  return (
    <Modal
      name='reset'
      onCloseModal={closeModal}
      layout='standard'
      styleOverride={styles.authModal}
      isCloseButtonVisible
    >
      <>
        <ResetPassword onDone={closeModal} />
      </>
    </Modal>
  )
}

export default ResetPasswordModal
